import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import NewsBgColorsData from "../../js/NewsBgColorsData";
import localimgpath from "../../js/localimgpath";
import { Animatespin, HeadingCom, SlideNewsCom } from "../../components/index";
import Functions from "./index.function";
const LatestNews = () => {
  const { isLoading, newsList, handleNews, sliderSettings } = Functions();
  return (
    <div className="bg-primary">
      <div className="lg:px-5 xl:px-10  xs:px-3 sm:py-6 sm:px-6 xs:py-5 m-auto lg:pt-16">
        <HeadingCom to={"/news"} title={"news"} />
      </div>
      <div className="lg:pt-14 xs:pt-5 sm:pt-6 lg:w-full">
        {isLoading === true ? (
          <Animatespin />
        ) : (
          <Slider {...sliderSettings}>
            {newsList?.news.map((value, index) => (
              <div key={index}>
                <SlideNewsCom
                  onClick={() => handleNews(value?.id)}
                  latestNewsthubmail={`${localimgpath?.newsThumbnail}/${value?.hero_image}`}
                  latestNewsTitle={value?.news_title}
                  alt={value?.news_title}
                  bgcolor={
                    NewsBgColorsData[index % NewsBgColorsData?.length].newstheme
                  }
                />
              </div>
            ))}
          </Slider>
        )}
      </div>
    </div>
  );
};

export default LatestNews;
